<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.38505 10.3198C3.44187 10.8814 0.96891 12.0281 2.47511 13.4631C3.21087 14.164 4.03033 14.6654 5.06058 14.6654H10.9394C11.9697 14.6654 12.7891 14.164 13.5249 13.4631C15.0311 12.0281 12.5581 10.8814 11.615 10.3198C9.40321 9.00279 6.59679 9.00279 4.38505 10.3198Z"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 4.33203C11 5.98889 9.65685 7.33203 8 7.33203C6.34315 7.33203 5 5.98889 5 4.33203C5 2.67518 6.34315 1.33203 8 1.33203C9.65685 1.33203 11 2.67518 11 4.33203Z"
      stroke="currentcolor"
    />
  </svg>
</template>
